import {UyapRequest} from "./UyapRequest";

export interface BankaHacziParamsTalep {
    // Boş
}

export interface BankaHacziParamsCevap {
    bankalar: Array<BankaHacziParamsBankaRow>,
    hesaplar: Array<BankaHacziParamsHesapRow>,
    evrakAdlari: Array<BankaHacziParamsEvrakAdiRow>,
    haric: Array<BankaHacziParamsHaricRow>
}

export interface BankaHacziParamsBankaRow {
    ilgiliKisiTipi: string,
    ilgili: string,
    asilTaraf: string,
    ilgiliKisiIlkKisiKurumId: number,
    asilTarafIlkKisiKurumId: number,
    ilgiliKisiRolu: string,
    ilgiliKisiRolId: number,
    secili: boolean,
    kisi: boolean,
    tcVatandasi: boolean,
    mersisNo: string,
    kisaAd: any
}

export interface BankaHacziParamsHesapRow {
    tktId: string,
    kod: string,
    aciklama: string
}

export interface BankaHacziParamsEvrakAdiRow {
    name: string,
    value: string,
}

export interface BankaHacziParamsHaricRow {
    name: string,
    value: string,
}

export default class BankaHacziParams extends UyapRequest<BankaHacziParamsTalep, BankaHacziParamsCevap> {
    delayTime = 0;

    getMethod(): "POST" | "GET" {
        return 'POST';
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "getBankaHacziParams_brd"
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'getBankaHacziParams_brd.ajx';
    }

    async parse(data: any): Promise<BankaHacziParamsCevap> {
        return {
            bankalar: data[0],
            hesaplar: data[1],
            evrakAdlari: data[2],
            haric: data[3]
        };
    }

    getMockResponse(): any {
        // yer kaplamaması için bazı ban
        return [[{"ilgiliKisiTipi":"H","ilgili":"QNB FİNANSBANK ANONİM ŞİRKETİ","asilTaraf":"QNB FİNANSBANK ANONİM ŞİRKETİ","ilgiliKisiIlkKisiKurumId":159238904,"asilTarafIlkKisiKurumId":159238904,"ilgiliKisiRolu":"Tebligat Yapılacak 3. Taraf","ilgiliKisiRolId":122,"secili":false,"kisi":false,"tcVatandasi":false,"mersisNo":"0388002333400576"},{"ilgiliKisiTipi":"H","ilgili":"TÜRKİYE FİNANS KATILIM BANKASI ANONİM ŞİRKETİ","asilTaraf":"TÜRKİYE FİNANS KATILIM BANKASI ANONİM ŞİRKETİ","ilgiliKisiIlkKisiKurumId":166411454,"asilTarafIlkKisiKurumId":166411454,"ilgiliKisiRolu":"Tebligat Yapılacak 3. Taraf","ilgiliKisiRolId":122,"secili":false,"kisi":false,"tcVatandasi":false,"mersisNo":"0068006387095226"},{"ilgiliKisiTipi":"H","ilgili":"GOLDEN GLOBAL YATIRIM BANKASI ANONİM ŞİRKETİ","asilTaraf":"GOLDEN GLOBAL YATIRIM BANKASI ANONİM ŞİRKETİ","ilgiliKisiIlkKisiKurumId":210885830,"asilTarafIlkKisiKurumId":210885830,"ilgiliKisiRolu":"Tebligat Yapılacak 3. Taraf","ilgiliKisiRolId":122,"secili":false,"kisi":false,"tcVatandasi":false,"mersisNo":"0396123319100001"},{"ilgiliKisiTipi":"H","ilgili":"FİBABANKA ANONİM ŞİRKETİ","asilTaraf":"FİBABANKA ANONİM ŞİRKETİ","ilgiliKisiIlkKisiKurumId":120150101,"asilTarafIlkKisiKurumId":120150101,"ilgiliKisiRolu":"Tebligat Yapılacak 3. Taraf","ilgiliKisiRolId":122,"secili":false,"kisi":false,"tcVatandasi":false,"mersisNo":"0209000780814852"}],[{"tktId":"HTBLG0001","kod":"00001","aciklama":"Vadesiz Türk Parası Hesabı"},{"tktId":"HTBLG0002","kod":"00002","aciklama":"Yatırım Hesabı Serbest Bakiye"},{"tktId":"HTBLG0003","kod":"00003","aciklama":"Vadesiz Yabancı Para Hesabı"},{"tktId":"HTBLG0004","kod":"00004","aciklama":"Kıymetli Maden Hesabı (Vadesiz Altın Hesabı Dahil)"},{"tktId":"HTBLG0005","kod":"00005","aciklama":"B Tipi Yatırım Fonu(B Tipi Likit ve Kısa Vadeli Tahvil-Bono Fonu)"},{"tktId":"HTBLG0006","kod":"00006","aciklama":"Hazine Bonosu & Devlet Tahvili(TL)"},{"tktId":"HTBLG0007","kod":"00007","aciklama":"Repo"},{"tktId":"HTBLG0008","kod":"00008","aciklama":"Diğer Fonlar ve A Tipi Yatırım Fonu"},{"tktId":"HTBLG0009","kod":"00009","aciklama":"Vadeli Türk Parası Hesabı"},{"tktId":"HTBLG0010","kod":"00010","aciklama":"Vadeli Yabancı Para Hesabı"},{"tktId":"HTBLG0011","kod":"00011","aciklama":"Kıymetli Maden Hesabı (Vadeli Altın Hesabı dahil)"},{"tktId":"HTBLG0012","kod":"00012","aciklama":"Anapara Koruma Amaçlı ve Anapara Garantili Fonlar"},{"tktId":"HTBLG0013","kod":"00013","aciklama":"Hisse Senedi"},{"tktId":"HTBLG0014","kod":"00014","aciklama":"Diğer (Hazine Bonosu & Devlet Tahvili/YP), Eurobond, VOB, Özel Sektör Tahvili v.b. menkul kıymetler)"},{"tktId":"HTBLG0015","kod":"00015","aciklama":"Alış Satış Emri Olan Kıymetler (Niteliği Değişebilen Varlıklar)"}],[{"name":"Haciz Müzekkeresi","value":"MZK"},{"name":"89/1 Haciz İhbarnamesi","value":"IHB"},{"name":"89/2 Haciz İhbarnamesi","value":"IHB_2"},{"name":"89/3 Haciz İhbarnamesi","value":"IHB_3"}],[{"name":"Maaş Hesabı Hariç","value":"MAAS"},{"name":"Borçlu Belediye İse; *5393 Sayılı Belediye Kanununun 15.maddesi kapsamındaki Alacakları Hariç","value":"BELEDIYE"}]];
    }
}


